import { useParams, useSearchParams } from 'react-router-dom';
import { useStateValue } from '../../index';
import { getRoomRateError, getRoomRateRequest, getRoomRateSuccess } from '../actions';
import loadRoomRate from '../queries';

const useRoomRate = () => {
  const [{ roomRate, booking }, dispatch] = useStateValue();
  const [searchParams] = useSearchParams();
  const { hotelId } = useParams();

  const setRoomRate = async (params) => {
    console.log(booking);
    console.log(searchParams);
    dispatch(getRoomRateRequest());
    const obj = { hotel_id: hotelId, ...params };
    console.log(obj);
    try {
      const req = await loadRoomRate(obj);
      const res = await req.json();
      console.log(req);
      if (req.status === 200) {
        dispatch(getRoomRateSuccess(res));
      } else {
        dispatch(getRoomRateError(res.data.detail));
      }
    } catch (error) {
      console.log('error');
      dispatch(getRoomRateError(error));
    }
  };

  return { roomRate, setRoomRate };
};

export default useRoomRate;
